import { gql } from '@apollo/client';

export const exposedEstate = gql`
  query ExposedEstate($estateId: Float!) {
    exposedEstate(estateId: $estateId) {
      id
      legalId
    }
  }
`;
